import FItemDate from '../FItem/Date';
import component from './component.vue';
import { toString } from '@/utils/date';
import { toDate } from '@/utils/string';

export default class FDateRange extends FItemDate {
  static mask = 'dd.MM.yyyy';

  __component = component;

  constructor(props) {
    super(props);
    this.set();
  }

  get data() {
    return {
      [this.__name]: this.toString(FDateRange.mask),
    };
  }

  get options() {
    return {
      min: this.min,
      max: this.max,
    };
  }

  set(value = {
    from: null,
    to: null,
  }) {
    super.set(value);
  }

  setValidatorMin() {
    return this;
  }

  setValidatorMax() {
    return this;
  }

  setValidatorRequire(message = 'Обязательное') {
    this.setValidator((value) => {
      if (!value?.to) {
        return Promise.reject(message);
      }
      return Promise.resolve();
    }, true);
    return this;
  }

  toString(mask = 'dd.MM.yyyy') {
    return {
      from: toString(this.value.from, mask),
      to: toString(this.value.to, mask),
    };
  }

  setString(date, mask = 'dd.MM.yyyy') {
    this.set({
      from: toDate(date?.from, mask),
      to: toDate(date?.to, mask),
    });
  }
}
